import { loadDevMessages, loadErrorMessages } from '@apollo/client/dev'
import { configureSentry } from '@utils/sentry'
import React, { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { isLocal } from './settings'

if (isLocal) {
  // Adds messages only in a dev environment
  loadDevMessages()
  loadErrorMessages()
}

configureSentry()

const root = createRoot(document.getElementById('root')!)

root.render(
  <StrictMode>
    <App />
  </StrictMode>
)
